import 'zone.js';  // Importação necessária para Angular
